<template>
  <el-dialog
    :visible.sync="dialogFormVisible"
    width="700px"
    :before-close="close"
    :title="titles[updateType]"
  >
    <el-form ref="form" :model="initForm" :rules="rules">
      <el-form-item label="菜单名" prop="name" label-width="180px">
        <el-input v-model="initForm.name"></el-input>
      </el-form-item>
      <el-form-item label="url" prop="url" label-width="180px">
        <el-input v-model="initForm.url"></el-input>
      </el-form-item>

      <el-form-item label="模块" prop="app" label-width="180px">
        <el-input v-model="initForm.app"></el-input>
      </el-form-item>
      <el-form-item label="页面" prop="menu_page" label-width="180px">
        <el-input v-model="initForm.menu_page"></el-input>
      </el-form-item>
      <el-form-item label="操作" prop="action" label-width="180px">
        <el-select v-model="initForm.action" placeholder="请选择">
          <el-option
            style="font-size:16px;"
            v-for="operat in operatsList"
            :label="operat.Name"
            :key="operat.Action"
            :value="operat.Action"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="$emit('close')">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { operatsList } from "@/components/Index/data.js";

export default {
  props: {
    initForm: {},
    updateType: {}
  },
  data() {
    return {
      dialogFormVisible: true,
      rules: {
        name: [
          {
            required: true,
            message: "请输入菜单名",
            trigger: "blur"
          }
        ],
        url: [
          {
            required: true,
            message: "请输入url",
            trigger: "blur"
          }
        ],
        app: [
          {
            required: true,
            message: "请输入模块",
            trigger: "blur"
          }
        ],
        menu_page: [
          {
            required: true,
            message: "请输入页面",
            trigger: "blur"
          }
        ],
        action: [
          {
            required: true,
            message: "请选择操作",
            trigger: "blur"
          }
        ]
      },
      titles: {
        add: "新增页面权限",
        edit: "编辑页面权限"
      },
      operatsList: operatsList
    };
  },
  mounted() {},
  methods: {
    close() {
      this.$emit("close");
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (!valid) return false;
        if (this.updateType === "edit") {
          let url = "menus/" + this.initForm.id + "/";
          this.$http["put"](url, this.initForm, () => {
            this.$baseNotice.message("编辑成功");
            this.$emit("close");
            this.$emit("update");
          });
        } else {
          let url = "menus/";
          this.$http["post"](url, this.initForm, () => {
            this.$baseNotice.message("新增成功");
            this.$emit("close");
            this.$emit("update");
          });
        }
      });
    }
  }
};
</script>
